import { useEffect, useState } from 'react';

// Display-only clock. The server owns timeout actions and rejects late requests.
export default function useTurnCountdown(deadlineUtc, serverTimeUtc) {
    const [seconds, setSeconds] = useState(null);
    useEffect(() => {
        const deadline = Date.parse(deadlineUtc);
        const serverNow = Date.parse(serverTimeUtc);
        if (!Number.isFinite(deadline)) { setSeconds(null); return; }
        const receivedAt = Date.now();
        const reference = Number.isFinite(serverNow) ? serverNow : receivedAt;
        const update = () => setSeconds(Math.max(0, Math.ceil((deadline - reference - (Date.now() - receivedAt)) / 1000)));
        update();
        const timer = setInterval(update, 250);
        return () => clearInterval(timer);
    }, [deadlineUtc, serverTimeUtc]);
    return seconds;
}
